import React from 'react'
import { useMediaQuery } from '@chakra-ui/media-query'
import { Box, Flex, Heading, Text } from '@chakra-ui/layout'
import Icon from '@chakra-ui/icon'
import { GiEnlightenment } from 'react-icons/gi'
import { MdLocalGroceryStore } from 'react-icons/md'
import { ImNewspaper } from 'react-icons/im'
import { SiBehance, SiStarship } from 'react-icons/si'
import { Center } from '@chakra-ui/react'
function Projects() {
  const [isNotSmallerScreen] = useMediaQuery('(min-width:600px)')

  return (
    <Flex
      direction={isNotSmallerScreen ? 'row' : 'column'}
      w='100%'
      maxWidth={{ base: '100vh', md: '130vh', lg: '130vh', xl: '130vh' }}
    >
      <Box alignSelf='center' px='1' py='16'>
        <Heading fontWeight='extrabold' color='cyan.500' size='3xl'>
          Projects
        </Heading>
        <Flex mt={2} align='center'>
          <Box as={SiStarship} color='orange.400' />
          <Text ml={1} fontSize='md'>
            <b>Click to view LIVE!</b>
          </Text>
        </Flex>
      </Box>

      <Box alignSelf='center' px='32' py='8'>
        <Center>
          <Text fontWeight='bold' fontSize='1xl' px='0.5'>
            Product Designer and Developer, specialised in WEB development.
          </Text>
        </Center>
        <Flex direction={isNotSmallerScreen ? 'row' : 'column'} mt={2}>
          <Flex
            rounded='xl'
            direction='column'
            mt={4}
            bg='green.600'
            h='25vh'
            w='25vh'
            justify='flex-end'
            cursor='pointer'
            _hover={{ bg: 'red.700' }}
            onClick={() => window.open('https://gingerfreshens.web.app')}
          >
            <Icon
              color='purple.400'
              p='4'
              as={MdLocalGroceryStore}
              w='24'
              h='24'
            />
            <Text color='white' p='4' fontSize='xl' fontWeight='semibold'>
              👑 Ginger Fresh
            </Text>
            <Flex></Flex>
          </Flex>
          <Flex
            rounded='xl'
            direction='column'
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg='blue.400'
            h='25vh'
            w='25vh'
            justify='flex-end'
            _hover={{ bg: 'orange.400' }}
            cursor='pointer'
            onClick={() => window.open('https://christ-news-aa213.web.app/')}
          >
            <Icon color='black' p='4' as={ImNewspaper} w='24' h='24' />
            <Text color='black' p='4' fontSize='xl' fontWeight='semibold'>
              📰 Christ News
            </Text>
          </Flex>
          <Flex
            rounded='xl'
            direction='column'
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg='yellow.700'
            h='25vh'
            w='25vh'
            justify='flex-end'
            _hover={{ bg: 'red.400' }}
            cursor='pointer'
            onClick={() => window.open('https://enlightme-ad.web.app/')}
          >
            <Icon as={GiEnlightenment} p='4' w='24' h='24' color='white' />
            <Text color='black' p='4' fontSize='xl' fontWeight='semibold'>
              🚀 Enlightenment
            </Text>
          </Flex>
          <Flex
            rounded='xl'
            direction='column'
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg='pink.500'
            h='25vh'
            w='25vh'
            justify='flex-end'
            _hover={{ bg: 'green.400' }}
            cursor='pointer'
            onClick={() =>
              window.open(
                'https://www.behance.net/gallery/118399723/Times-of-Christ'
              )
            }
          >
            <Icon as={SiBehance} p='4' w='24' h='24' color='black' />
            <Text color='black' p='4' fontSize='xl' fontWeight='semibold'>
              📜 Times of Christ
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  )
}

export default Projects
